<div
    class="cipo--flex--column cipo--gap--xl"
    data-testid="module-config-list-skeleton"
    role="status"
    [attr.aria-busy]="true"
    [attr.aria-label]="label() | translate">
    @for (group of groups(); track $index) {
        <div class="cipo--flex--column cipo--gap--lg">
            @if (sections()) {
                <div class="cipo--flex--row cipo--align--center cipo--gap--sm">
                    <ngx-skeleton-loader appearance="circle" [theme]="theme.sectionIcon" />
                    <ngx-skeleton-loader [theme]="theme.sectionTitle" />
                </div>
            }

            @for (row of group; track $index) {
                <div
                    class="cipo-outlined-field cipo--flex--row cipo--flex--wrap cipo--justify--between cipo--align--center cipo--gap--lg p-y-md p-x">
                    <div
                        class="cipo--flex--column cipo--gap--sm cipo--flex--1 cipo--min-width--200 cipo--overflow--hidden">
                        @if (chip()) {
                            <div class="cipo--flex--row cipo--align--center cipo--gap--md">
                                <ngx-skeleton-loader [theme]="theme.chip" />
                                <ngx-skeleton-loader [theme]="theme.chipType" />
                            </div>
                        } @else {
                            <div class="cipo--flex--row cipo--align--center cipo--gap--sm">
                                <ngx-skeleton-loader
                                    class="cipo--flex--none"
                                    [style.width]="row.title"
                                    [theme]="theme.title" />
                                @if (row.badge) {
                                    <ngx-skeleton-loader class="cipo--flex--none" [theme]="theme.badge" />
                                }
                            </div>
                            @for (detail of row.details; track $index) {
                                <ngx-skeleton-loader [theme]="detail" />
                            }
                        }
                    </div>

                    <div
                        class="cipo--flex--row cipo--justify--end cipo--align--center cipo--gap--xs cipo--flex--none m-l-auto">
                        @for (action of actionList(); track action) {
                            <span
                                class="cipo--flex--row cipo--justify--center cipo--align--center cipo--flex--none cipo--width--40">
                                <ngx-skeleton-loader appearance="circle" [theme]="theme.icon" />
                            </span>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
